import React from "react";

const ArrowButtonLeft = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" {...props}>
      <path
        data-name="Trazado 1323"
        d="m8.75 1.061-8 8 8 8"
        fill="none"
        stroke="#202d5b"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
      />
    </svg>
  );
};

export default ArrowButtonLeft;
